export default __webpack_public_path__ + "static/media/search.4cee1ab9.svg";